
import ScoreManager from '../Utils/ScoreManager.js'
export default function showQuizOverlay() {
    const overlay = document.getElementById('quizOverlay')
    const resultBox = document.getElementById('quiz-result')
    const scoreEl = document.getElementById('quiz-score')
    const maxScoreEl = document.getElementById('quiz-max-score')
    const percentEl = document.getElementById('quiz-percent')

    // Show overlay
    overlay.classList.remove('hidden')

    // Schließen
    document.getElementById('quizCloseBtn').onclick = () => {
        overlay.classList.add('hidden')
    }

    // Auswertung
    document.getElementById('quizCheckBtn').onclick = () => {
        let score = 0
        const total = 3

        // Reset farbige Felder
        document.querySelectorAll('.quiz-question').forEach(el => {
            el.classList.remove('correct', 'incorrect')
        })

        // Frage 1
        const q1 = document.querySelector('input[name="q1"]:checked')
        if (q1 && q1.value === 'b') score++
        else markIncorrect(0)

        // Frage 2
        const q2 = document.querySelector('input[name="q2"]:checked')
        if (q2 && q2.value === 'b') score++
        else markIncorrect(1)

        // Frage 3
        const q3 = Array.from(document.querySelectorAll('input[name="q3"]:checked')).map(el => el.value)
        const correctQ3 = ['b', 'c', 'd']
        const isCorrectQ3 = correctQ3.every(val => q3.includes(val)) && q3.length === correctQ3.length
        if (isCorrectQ3) score++
        else markIncorrect(2)

        // Ergebnis anzeigen
        const percent = Math.round((score / total) * 100)
        resultBox.classList.remove('hidden')
        scoreEl.innerText = score
        maxScoreEl.innerText = total
        percentEl.innerText = percent

        resultBox.style.backgroundColor =
            percent >= 75 ? '#4caf50' :
            percent >= 50 ? '#ffc107' :
            percent >= 25 ? '#ff9800' : '#f44336'
    }

    function markIncorrect(index) {
        const question = document.querySelectorAll('.quiz-question')[index]
        question.classList.add('incorrect')
    }
}
